import { PushNotificationsClient } from 'nwa-push-notifications';
import CONFIG from '../../configs/config';

let pushNotificationsClientInstance;

/**
 * Returns an instance of the PushNotificationsClient, which handles the
 * subscription/unsubscription and sending of push notifications.
 *
 * @returns {PushNotificationsClient} the instance of PushNotificationsClient
 */
export function getPushNotificationsClientInstance() {
    if (!pushNotificationsClientInstance) {
        pushNotificationsClientInstance = new PushNotificationsClient(SERVICE_WORKER_PATH, CONFIG.publicVapidKey);
    }
    return pushNotificationsClientInstance;
}
